module.exports = __webpack_public_path__ + "img/1557242292.b6ad91f8.jpg";